"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrubRoutingNumber = void 0;
const REMOVE_ALL_ALPHA_CHARACTERS_REGEX = /[^\d.-]/g;
function scrubRoutingNumber(routingNumber) {
    return routingNumber.replace(REMOVE_ALL_ALPHA_CHARACTERS_REGEX, '');
}
exports.scrubRoutingNumber = scrubRoutingNumber;
//# sourceMappingURL=routing-number-scrubber.js.map